import React, { ReactElement } from 'react';
import { Img, Txt } from 'Components/GenericView';
import MedicalServices from "Components/MedicalServicesDropdown";

import {
  isMY,
  isSG,
  preferred_cps_option,
} from "DataConstants";
import './style.css';

export type MedicalConditionsPropType = {
  selectedMedicals: Array<string>;
  goneIfReadOnly: string;
  hasError: string | undefined;
  medicalList: any;
  mealRequirements: any;
  isReadOnly: boolean | undefined;
  dontAnimate: boolean | undefined;
  onMedicalChange: (requestedServices: any[], mealRequirements: any[]) => void;
  value: any;
};

const MedicalConditions = (props: MedicalConditionsPropType): ReactElement | null => {
  const {
    selectedMedicals,
    goneIfReadOnly,
    hasError,
    medicalList,
    mealRequirements,
    isReadOnly,
    dontAnimate,
    onMedicalChange,
    value,
  } = props;

  const hasmedicallist = medicalList.length <= 0;

  const featureIsAvailableInCountry = () => {
    if (isSG || isMY) {
      return true;
    };

    return false;
  };

  const renderTitle = () => {
    if (isReadOnly) {
      return <Txt className="nvd-text no-shrink medical-title" width={86 + 23 + 18}>
        Medical Conditions
      </Txt>
    };

    return null;
  };

  const isStaging = process.env.REACT_APP_API_URL?.includes('testing');

  let isFeatureEnabled = featureIsAvailableInCountry();
  isFeatureEnabled = isStaging ? true : isFeatureEnabled;

  if (isFeatureEnabled && value != "hard") {

    return (
      <div
        className={`nvd-row h${!selectedMedicals[0] ? goneIfReadOnly : ""}`}
        has-error={hasError}
      >
        <Img src="/medical_history.png" className="nvd-icon" />
        <i className="nvd-star">*</i>

        <div className="v grow">

          <div className="v grow">
            {renderTitle()}
            <MedicalServices
              className="nvd-services"
              tdClassName="nvd-service"
              tdInputClassName="nvd-add-adl add-medical"
              medicalList={medicalList}
              medical_conditions={hasmedicallist ? [] : selectedMedicals}
              meal_requirements={mealRequirements}
              readOnly={isReadOnly}
              hidden={isReadOnly}
              dontAnimate={dontAnimate}
              onMedicalChange={onMedicalChange}
              value={[preferred_cps_option]}
            >
            </MedicalServices>
          </div>
        </div>
      </div>
    )
  }

  return null;
};

export default MedicalConditions;